// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automations-triggers-container[data-v-b78b7968]{height:100%!important;overflow:auto}", ""]);
// Exports
module.exports = exports;
